import { guid } from "../../../Util/guid";

const DEFAULT_EVENT = '__DEFAULT__';

//Allow subscription to specific events by name
const eventSubscriptionStore = {};

//Keep track of what id is subscribed to which event for easy lookup on unsubscribe
const subscriptionIdEventMapping = {};

const getEventSubscriptionStore = (eventName) => {
    //Create an event subscription store when necessary
    if(!eventSubscriptionStore.hasOwnProperty(eventName)){
        eventSubscriptionStore[eventName] = [];
    }
	
    return eventSubscriptionStore[eventName];
};

const deleteEventSubscriptionStore = (eventName) => {
    //Clear up reference to event subscription store
    if(eventSubscriptionStore.hasOwnProperty(eventName)){
        delete eventSubscriptionStore[eventName];
    }
};

const subscribe = (func, eventName = DEFAULT_EVENT) => {
    let id = guid();
	
    //Store our event
    getEventSubscriptionStore(eventName).push({id: id, func: func});
	
    //Store the event belonging to our subscription id
    subscriptionIdEventMapping[id] = eventName;
	
    return id;
};

const executeAsync = function(eventName){
    return new Promise((resolve) => {
        execute(...arguments);
        resolve();
    });
};

const execute = function(eventName = DEFAULT_EVENT){
    //Take all but the event name
    const parameters = new Array(...arguments).slice(1, arguments.length);
	
    getEventSubscriptionStore(eventName).forEach((subscriber) => {
        subscriber.func.apply(subscriber.func, parameters);
    });
};

const unsubscribe = (id) => {
    //Check whether we're dealing with a known id
    if(!subscriptionIdEventMapping.hasOwnProperty(id)) {
        return;
    }
	
    const eventName = subscriptionIdEventMapping[id];
    const subscriptions = getEventSubscriptionStore(eventName);

    //Remove our subscription from the mapping
    delete subscriptionIdEventMapping[id];
	
    let target = subscriptions.find((subscriber) => {
        return subscriber.id === id;
    });
    let index = subscriptions.indexOf(target);

    subscriptions.splice(index, 1);
	
    if(subscriptions.length === 0){
        deleteEventSubscriptionStore(eventName);
    }
};

export {
    subscribe,
    execute,
    executeAsync,
    unsubscribe
};

export default {
    subscribe,
    execute,
    executeAsync,
    unsubscribe
};